import axios from 'axios'

const instance = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}management-transport/`,
    headers: {
        'Content-Type': 'application/json'
    }
})

const formatAuthorization = idToken => idToken + '.' + btoa(JSON.stringify({ 'id': process.env.REACT_APP_ID }))



function returnType(response) {
    if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'local') {
        response = typeof response === 'string' ? JSON.parse(response) : response
    }
    return response
}

export default {
    getTransport: (idToken, data) => new Promise((resolve, reject) => {
        instance.post(
            'searchTransport',
            {
                data
            },
            {
                headers: {
                    Authorization: formatAuthorization(idToken)
                }
            }
        ).then(response => {
            if (response.status === 200) {
                resolve(returnType(response.data))
            }
            else {
                reject(new Error('Couldn\'t retrieve data'))
            }
        })
            .catch(error => {
                reject(error)
            })
    }),
    getInfoTransport: (idToken, data) => new Promise((resolve, reject) => {
        instance.post(
            'informationTransport',
            {
                data
            },
            {
                headers: {
                    Authorization: formatAuthorization(idToken)
                }
            }
        ).then(response => {
            if (response.status === 200) {
                resolve(returnType(response.data))
            }
            else {
                reject(new Error('Couldn\'t retrieve data'))
            }
        })
            .catch(error => {
                reject(error)
            })
    }),

    manageAttachments: (idToken, data, option) => new Promise((resolve, reject) => {
        instance.post(
            'manageAttachments',
            {
                data, option
            },
            {
                headers: {
                    Authorization: formatAuthorization(idToken)
                }
            }
        ).then(response => {
            if (response.status === 200) {
                resolve(returnType(response.data))
            }
            else {
                reject(new Error('Couldn\'t retrieve data'))
            }
        })
            .catch(error => {
                reject(error)
            })
    }),

    changeStatus: (idToken, data) => new Promise((resolve, reject) => {
        instance.post(
            'changeStatus',
            {
                data
            },
            {
                headers: {
                    Authorization: formatAuthorization(idToken)
                }
            }
        ).then(response => {
            if (response.status === 200) {
                resolve(returnType(response.data))
            }
            else {
                reject(new Error('Couldn\'t retrieve data'))
            }
        })
            .catch(error => {
                reject(error)
            })
    }),

    getAttachSGRO: (idToken, data) => new Promise((resolve, reject) => {
        instance.post(
            'get-sgro-file',
            {
                key: data
            },
            {
                headers: {
                    Authorization: formatAuthorization(idToken)
                }
            }
        ).then(response => {
            if (response.status === 200) {
                resolve(returnType(response.data))
            }
            else {
                reject(new Error('Couldn\'t retrieve data'))
            }
        })
            .catch(error => {
                reject(error)
            })
    }),

}